var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckTransportSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 39.934,
    viewBox: "0 0 50 39.934",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "truck-transport-svgrepo-com",
    transform: "translate(1 -50.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(-1 50.626)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25",
    "data-name": "Group 25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M48.251,64.52l-7.238-7.987a2.979,2.979,0,0,0-2.08-.915H30.614V53.871a3.179,3.179,0,0,0-3.161-3.245H2.245A3.2,3.2,0,0,0-1,53.871V82.656a2.948,2.948,0,0,0,2.912,2.912H3.219a5.825,5.825,0,0,0,11.53,0h18.42a5.825,5.825,0,0,0,11.53,0H49V66.433A2.636,2.636,0,0,0,48.251,64.52ZM46.92,65.6a.9.9,0,0,1,.333.749v2.579H34.774V60.609h7.571ZM.664,68.1H12.311a.832.832,0,1,0,0-1.664H.664v-2.5H8.983a.832.832,0,0,0,0-1.664H.664v-8.4A1.53,1.53,0,0,1,2.245,52.29H27.369a1.58,1.58,0,0,1,1.581,1.581v20.05H.664ZM8.983,88.9a4.16,4.16,0,1,1,4.16-4.16A4.119,4.119,0,0,1,8.983,88.9ZM28.95,83.9h-14.2A5.775,5.775,0,0,0,9.53,78.938l-.06,0c-.068-.005-.136-.011-.205-.014-.093,0-.187-.007-.281-.007s-.188,0-.281.007c-.069,0-.137.009-.205.014l-.06,0A5.775,5.775,0,0,0,3.218,83.9H1.912A1.279,1.279,0,0,1,.664,82.656V75.585H28.95ZM38.933,88.9a4.16,4.16,0,1,1,4.16-4.16A4.119,4.119,0,0,1,38.933,88.9ZM44.7,83.9a5.775,5.775,0,0,0-5.219-4.966l-.06,0c-.068-.005-.136-.011-.205-.014-.093,0-.187-.007-.281-.007s-.188,0-.281.007c-.069,0-.137.009-.205.014l-.06,0A5.775,5.775,0,0,0,33.169,83.9H30.614V57.282h8.32a1.757,1.757,0,0,1,.832.333l1.192,1.331H34.524A1.458,1.458,0,0,0,33.11,60.36v8.819a1.458,1.458,0,0,0,1.414,1.414H47.253v4.16h-4.16a.832.832,0,0,0,0,1.664h4.16V83.9H44.7Z",
    transform: "translate(1 -50.626)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M85.833,383.427a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,85.833,383.427Z",
    transform: "translate(-75.833 -350.515)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M393.033,383.427a1.5,1.5,0,1,0,1.5,1.5A1.5,1.5,0,0,0,393.033,383.427Z",
    transform: "translate(-353.033 -350.515)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTransportSvgrepoCom);
export default __webpack_public_path__ + "static/media/truck-transport-svgrepo-com.8f5ed1a6483326ae5fe55a9fac4abc74.svg";
export { ForwardRef as ReactComponent };